<div *ngIf="showModalCom" (click)="closeCommMsgModal()" class="detailsModal no-scroll">
	<div class="msg-box" (click)="$event.stopPropagation()">
		<div class="modal-details-header">
			<h4 style="font-size: 25px; font-weight: 600;margin:0 !important">
				{{"MESSAGE"|translate}}
			</h4>
			<span style="cursor: pointer" (click)="closeCommMsgModal()" aria-label="Close">
				<i class="fa fa-times" aria-hidden="true"></i>
			</span>
		</div>
		<div class="modal-details-content" *ngIf="selectedCommunication">
			<div class="message-card">
				<div class="meta-row">
					<div class="meta-item">
						<span class="meta-label">{{ "FROM" | translate }}</span>
						<span *ngIf="activeTab === 'received'" class="meta-value">{{ selectedCommunication.sender
							}}</span>
						<span *ngIf="activeTab === 'sent'" class="meta-value">{{ selectedCommunication.sender }} - {{
							selectedCommunication.username }}</span>
					</div>

					<div class="meta-item">
						<span class="meta-label">{{ "DATE" | translate }}</span>
						<span class="meta-value">{{ selectedCommunication.date }}</span>
					</div>
				</div>

				<div class=""
					*ngIf="selectedCommunication.type === 'ADMIN-BOOKING' || selectedCommunication.type === 'AGENCY-BOOKING'">
					<a [href]="buildLink(selectedCommunication)"
						target="_blank"
						style="color: #007bff; text-decoration: underline;font-size: 14px; font-weight: 500;">
						{{ "VIEW_BOOKING" | translate }}
					</a>
				</div>

				<div class="meta-item subject">
					<span class="meta-label">{{ "SUBJECT" | translate }}</span>
					<span class="meta-value">{{ selectedCommunication.subject }}</span>
				</div>
			</div>
			<div class="message-body" [innerHTML]="selectedCommunication.body"></div>
			<div *ngIf="selectedCommunication.files && selectedCommunication.files.length" class="attachments">
				<h4>Attachments</h4>
				<div class="files">
					<div class="file-card" *ngFor="let file of selectedCommunication.files">
						<div class="file-icon">
							{{ file.file_path.split('.').pop().toUpperCase() }}
						</div>

						<div class="file-info">
							<div class="file-name">
								{{ file.file_path.split('/').pop() }}
							</div>

							<button class="file-open" (click)="openAttachment(file.file_path)">
								Open
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-details-footer" style="justify-content: flex-end;">
			<button type="button" (click)="closeCommMsgModal()" class="btn btn-primary send-btn">
				{{ "CLOSE"|translate }}
			</button>
		</div>
	</div>
</div>

<div *ngIf="openMessagModal" (click)="closeMessageModal()" class="detailsModal no-scroll">
	<div class="msg-box" (click)="$event.stopPropagation()">
		<div class="modal-details-header">
			<h4 style="font-size: 25px; font-weight: 600;margin:0 !important">
				{{"MESSAGE"|translate}}
			</h4>
			<span style="cursor: pointer" (click)="closeMessageModal()" aria-label="Close">
				<i class="fa fa-times" aria-hidden="true"></i>
			</span>
		</div>
		<div class="modal-details-content">
			<div class="inp-wrap" style="margin-top: 10px;">
				<label for="pnrInput">{{ 'SUBJECT' | translate }}</label>
				<input type="text" class="form-control" id="pnrInput" placeholder="Write a subject"
					[(ngModel)]="subject" />
			</div>
			<div class="inp-wrap" style="margin-top: 10px;">
				<label for="pnrInput">{{ 'CONTENT' | translate }}</label>
				<quill-editor (onContentChanged)="onContentChanged($event)" [(ngModel)]="content" theme="snow">
				</quill-editor>
			</div>
		</div>
		<div class="modal-details-footer">
			<button [disabled]="uploadingFile" [class.btnDisabled]="uploadingFile" class="btn btn-ghost"
				(click)="fileInput.click()">
				<i class="fa fa-link" style="font-size: 20px;"></i>
				{{ "UPLOAD_FILE" | translate }}
				<span *ngIf="uploadingFile">
					<i class="fa fa-spinner fa-fw fa-spin"></i>
				</span>
			</button>
			<input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;"
				accept="image/*,application/pdf">
			<button type="button" (click)="sendMessage()" [class.btnDisabled]="!canSendMessage()"
				class="btn btn-primary send-btn" [disabled]="!canSendMessage()">
				{{ "SEND"|translate }}
				<span *ngIf="sendingMessage">
					<i class="fa fa-spinner fa-fw fa-spin"></i>
				</span>
			</button>
		</div>
	</div>
</div>

<section *ngIf="clientAssets !== 'skybook'">
	<div class="row page-title" style="padding: 20px 0px !important">
		<div class="container clear-padding text-start flight-title" style="padding-inline: 15px !important">
			<h3>{{ "COMMUNICATIONS" | translate }}</h3>
		</div>
	</div>
</section>

<div *ngIf="clientAssets === 'skybook'" class=" " style="width: 100%; height: 250px;position: relative;">
	<div class=""
		style="position: absolute; transform: translate(-50% , -50%); top: 65%;left: 50%; text-align: center;z-index: 2;">
		<h1 style="font-size: 45px; font-weight: bold;color: white; font-family: Helvetica, sans-serif; ">{{
			"COMMUNICATIONS" | translate }}</h1>
	</div>
	<div class="overlay" style="position: absolute;inset: 0; background-color: rgba(0, 0, 0, .3); z-index: 1;"></div>
	<img src="../../../../../assets/algerie-booking/images/bg-image16.jpg"
		style="width: 100%;height: 100%; object-fit: cover; " alt="visabg" srcset="">
</div>

<div class="top-baner bg-grey-2">
	<div class="container clear-padding" style="padding-inline: 10px;">
		<div class="action-holder">
			<div class="comm-tabs">
				<div class="tab-item" [class.active]="activeTab === 'received'" (click)="setTab('received')">
					{{ "RECEIVED_MESSAGES" | translate }}
				</div>

				<div class="tab-item" [class.active]="activeTab === 'sent'" (click)="setTab('sent')">
					{{ "SENT_MESSAGES" | translate }}
				</div>
			</div>
			<button class="btn btn-primary send-btn" (click)="openMessageModal()">
				{{ "SEND_MESSAGE" | translate }}
			</button>
		</div>

		<!-- RECEIVED -->
		<ng-container *ngIf="activeTab === 'received'">
			<div class="row no-margin">
				<div class="find-form no-padding col-xs-12 col-md-12" style="padding-inline: 0 !important;">
					<div class="col-sm-12 col-xs-12 clear-padding" style="overflow-x: auto;">
						<table id="table1" class="table modern-table">
							<thead>
								<tr>
									<th scope="col">
										{{ "FROM" | translate }}
									</th>

									<th scope="col">
										{{ "SUBJECT" | translate }}
									</th>

									<th scope="col">
										{{ "DATE" | translate }}
									</th>
								</tr>
							</thead>

							<tbody>
								<ng-container *ngIf="loading">
									<tr *ngFor="let row of skeletonRows">
										<td>
											<div class="skeleton skeleton-text short"></div>
										</td>
										<td>
											<div class="skeleton skeleton-text medium"></div>
										</td>
										<td>
											<div class="skeleton skeleton-text small"></div>
										</td>
									</tr>
								</ng-container>
								<ng-container *ngIf="!loading">
									<tr *ngFor="let com of communications; index as i" class="trow"
										[ngClass]="{ unread: !com.read }" valign="middle"
										(click)="openCommunication(com)">
										<td>
											<span class="icon-location">
												<!-- green dot -->
												<span *ngIf="!com.read" class="unread-dot"></span>
											</span>
											<span class="text-bold sender">{{ com.sender }}</span>
										</td>

										<td>
											<span class="icon-location"></span>
											<span class="text-bold">{{ com.subject }}</span>
										</td>

										<td>
											<span class="icon-location"></span>
											<span class="text-bold">{{ com.date }}</span>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>

						<div class="pagination">
							<div class="">

								<b>{{ total }} </b>
								<span class="fw600" style="text-transform: lowercase">{{
									"COMMUNICATIONS" | translate
									}}</span>
							</div>
							<div class="" style="display: flex;gap:10px">
								<div class="per-page">
									<span class="fw600" style="margin-right: 5px">{{ "PER_PAGE" | translate }} : </span>
									<!-- <input type="number" [(ngModel)]="perPage"  min="1" max="100" style="margin-right: 5px;"> -->
									<select name="perPage" [(ngModel)]="perPage" (change)="page = 1; getAllcoms()">
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
									</select>
									<!-- <button (click)="getAllcoms()">{{"RELOAD"|translate}}</button> -->
								</div>
								<div class="per-page">
									<span class="fw600" style="margin-right: 5px">{{ "PAGE" | translate }} : </span>
									<!-- <input type="number" [(ngModel)]="perPage"  min="1" max="100" style="margin-right: 5px;"> -->
									<select name="perPage" [(ngModel)]="page" (change)="getAllcoms()">
										<option *ngFor="let page_i of numbers" [value]="page_i + 1">
											{{ page_i + 1 }}
										</option>
									</select>
									<!-- <button (click)="getAllcoms()">{{"RELOAD"|translate}}</button> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- SENT -->
		<ng-container *ngIf="activeTab === 'sent'">
			<div class="row no-margin">
				<div class="find-form no-padding col-xs-12 col-md-12" style="padding-inline: 0 !important;">
					<div class="col-sm-12 col-xs-12 clear-padding" style="overflow-x: auto;">
						<table id="table1" class="table modern-table">
							<thead>
								<tr>
									<th scope="col">
										{{ "TO" | translate }}
									</th>
									<th scope="col">
										{{ "TYPE" | translate }}
									</th>
									<th scope="col">
										{{ "SUBJECT" | translate }}
									</th>

									<th scope="col">
										{{ "DATE" | translate }}
									</th>
								</tr>
							</thead>

							<tbody>
								<ng-container *ngIf="sentLoading">
									<tr *ngFor="let row of skeletonRows">
										<td>
											<div class="skeleton skeleton-text short"></div>
										</td>
										<td>
											<div class="skeleton skeleton-text short"></div>
										</td>
										<td>
											<div class="skeleton skeleton-text medium"></div>
										</td>
										<td>
											<div class="skeleton skeleton-text small"></div>
										</td>
									</tr>
								</ng-container>
								<ng-container *ngIf="!sentLoading">
									<tr *ngFor="let com of sentCommunications; index as i" class="trow" valign="middle"
										(click)="openCommunication(com)">
										<td>
											<span class="text-bold " *ngIf="typeDict[com.type.replace('-', '_')]">{{
												"TO_" + com.type.replace('-', '_') | translate }}</span>
											<span class="text-bold " *ngIf="!typeDict[com.type.replace('-', '_')]">{{
												"--" }}</span>
										</td>

										<td>
											<span class="icon-location"></span>
											<span class="text-bold" *ngIf="com.product">{{ com.product | translate
												}}</span>
											<span class="text-bold" *ngIf="!com.product">{{ "--" }}</span>
										</td>

										<td>
											<span class="icon-location"></span>
											<span class="text-bold">{{ com.subject || " -- " }}</span>
										</td>

										<td>
											<span class="icon-location"></span>
											<span class="text-bold">{{ com.date }}</span>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>

						<div class="pagination">
							<div class="">

								<b>{{ total }} </b>
								<span class="fw600" style="text-transform: lowercase">{{
									"COMMUNICATIONS" | translate
									}}</span>
							</div>
							<div class="" style="display: flex;gap:10px">
								<div class="per-page">
									<span class="fw600" style="margin-right: 5px">{{ "PER_PAGE" | translate }} : </span>
									<!-- <input type="number" [(ngModel)]="perPage"  min="1" max="100" style="margin-right: 5px;"> -->
									<select name="perPage" [(ngModel)]="sentPerPage"
										(change)="sentPage = 1; getSentComs()">
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
									</select>
									<!-- <button (click)="getAllcoms()">{{"RELOAD"|translate}}</button> -->
								</div>
								<div class="per-page">
									<span class="fw600" style="margin-right: 5px">{{ "PAGE" | translate }} : </span>
									<!-- <input type="number" [(ngModel)]="perPage"  min="1" max="100" style="margin-right: 5px;"> -->
									<select name="sentPerPage" [(ngModel)]="sentPage" (change)="getSentcoms()">
										<option *ngFor="let page_i of sentNumbers" [value]="page_i + 1">
											{{ page_i + 1 }}
										</option>
									</select>
									<!-- <button (click)="getAllcoms()">{{"RELOAD"|translate}}</button> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>